export default {
  CLICK_TO_FILL: `Si vous avez un quart de travail aujourd'hui vous devez remplir le questionnaire journalier. Cliquez ici pour le faire.`,
  CLICK_TO_REFILL: `Vous avez rempli le questionnaire journalier et avez vu le message d'avertissement. Cliquez ici pour changer vos réponses`,
  FILLED_CLICK_TO_FILL_AGAIN: `Vous avez rempli le questionnaire journalier. Cliquez ici pour répondre de nouveau.`,
  QUESTIONNAIRE_MODAL: {
    TITLE: `Questionnaire journalier`,
    SUMMARY: ``,
    ANSWER_ALL_QUESTIONS: `Veuillez répondre à toutes les questions.`,
    ERROR_TRIGGERED: `En raison de vos réponses au questionnaire, vous devrez contacter votre gestionnaire.`,
    HAS_ERROR: `Il y a eu une erreur, veuillez ressayer.`,
    THANK_YOU: `Merci d'avoir rempli le questionnaire!`,
    EXPLANATION_WARNING: `Vous avez récemment répondu au questionnaire de manière à recevoir un message d'erreur.`,
    EXPLANATION: {
      LABEL: `Explication`,
      PLACEHOLDER: `Indiquez la raison du changement de vos réponses.`,
      DESCRIPTION: ``
    }
  }
}
